import { Flex, Text } from '@chakra-ui/react';
import { formatter } from 'components/Leaderboard/LeaderboardTable/columns';
import { IconFusion, IconShoppingCart, IconUpgradeNew, IconWrenchTune } from 'icons';
interface OrderTotalProps {
  total: number;
  type?: 'fusion' | 'tuneUp' | 'upgrade' | 'default';
}

const variables = {
  fusion: {
    icon: <IconFusion />,
    text: 'Fusion Cost'
  },
  tuneUp: {
    icon: <IconWrenchTune />,
    text: 'Tune-Up Cost'
  },
  upgrade: {
    icon: 
    <IconUpgradeNew 
      width={{ base: '1rem', md: '1.5rem' }}
      height={{ base: '1rem', md: '1.5rem' }}
      __css={{
        path: {
          fill: 'white.80',
        },
      }}
    />,
    text: 'Upgrade Cost'
  },
  default: {
    icon: <IconShoppingCart />,
    text: 'Order Total'
  }
}

const OrderTotal = ({ total, type = 'default' }: OrderTotalProps) => {
  return (
    <Flex
      background="linear-gradient(90deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%)"
      p="3"
      borderRadius="0.25rem"
      justifyContent="space-between"
      alignItems="center"
      w="full"
      position="relative"
      _before={{
        content: '""',
        position: 'absolute',
        inset: 0,
        padding: '2px',
        borderRadius: '0.25rem',
        background: 'linear-gradient(90deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%)',
        mask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
        maskComposite: "exclude",
      }}
    >
      <Flex alignItems="center" gap="2">
        {variables[type].icon}
        <Text
          fontSize={{ base: '0.875rem', md: '1.125rem' }}
          lineHeight={{ base: '1.125rem', md: '1.5rem' }}
          fontWeight="600"
          color="white.80"
        >
          {variables[type].text}
        </Text>
      </Flex>

      <Text
        fontSize={{ base: '0.875rem', md: '1.125rem' }}
        lineHeight={{ base: '1.125rem', md: '1.5rem' }}
        fontWeight="600"
        color="treasuredTeal.100"
      >
        {formatter.format(total)}
      </Text>
    </Flex>
  );
};

export default OrderTotal;
